import React from "react";

import "../styles/bulma_loader.scss";

const Termine2026 = () => {
  return (
    <div className="content is-size-5">
      <h1 className="title" id="termine-2026">
        Termine 2026
      </h1>

      <p>
        Die wichtigsten Termine und Veranstaltungen der Schützengilde für 2026.
      </p>

      <div className="columns mt-4">
        <div className="column is-half">
          <div className="box">
            <h2 className="subtitle is-4">
              <a href="#vereinsmeisterschaft-2026">
                Vereinsmeisterschaft 2026
              </a>
            </h2>
            <p>Vereinsmeisterschaft vom 05.07. bis 27.09.2026</p>
            <p className="mt-3">
              <a
                href="#vereinsmeisterschaft-2026"
                className="button is-primary is-small"
              >
                Details ansehen →
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="box mt-4">
        <h2 className="subtitle is-4">Weitere Termine</h2>
        <p>
          Alle weiteren Termine und regelmäßigen Veranstaltungen finden Sie in
          unserem Terminkalender.
        </p>
        <p className="mt-3">
          <a href="/Kalender#title" className="button is-primary is-small">
            Zum Terminkalender →
          </a>
        </p>
      </div>
    </div>
  );
};

export default Termine2026;
